import clsx from 'clsx';

const OPTIONS = [
  { value: 'all', label: 'All time' },
  { value: 'month', label: '30 days' },
  { value: 'week', label: '7 days' },
  { value: 'today', label: 'Today' },
] as const;

export type Period = (typeof OPTIONS)[number]['value'];

export function PeriodToggle({
  value,
  onChange,
}: {
  value: Period;
  onChange: (period: Period) => void;
}) {
  return (
    <div className="inline-flex gap-1 rounded-lg bg-gray-100 dark:bg-zinc-900 p-1">
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={clsx(
            'rounded-md px-3 py-1.5 text-sm transition-colors',
            value === option.value
              ? 'bg-white dark:bg-zinc-700 shadow-sm font-medium text-gray-900 dark:text-zinc-100'
              : 'text-gray-500 dark:text-zinc-400 hover:text-gray-700 dark:hover:text-zinc-200',
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
